class Address {
    id: number;
    line1: string;
    line2: string;
    city: string;
    state: number;
    stateName: string;
    country: number;
    countryName: string;
    postcode: string;

    constructor(data?: Partial<Address>) {
        Object.assign(this, data);
    }
}

export default Address;